import ReactApexChart from "react-apexcharts";


export const apexColors = ['#4b5563', '#22c55e'];

export const DeduplicationDonut = ({stats}) => {
    const series = [ stats.totalCount-stats.deduplicatedCount, stats.deduplicatedCount];
    const options = {
        chart: {
            type: 'donut',
        },
        colors:apexColors,
        dataLabels: {
            enabled: false,
        },
        labels: [ 'Non deduplicated count','Deduplicated count'],
        legend: {
            show: true,
            position: 'left',
            horizontalAlign: 'left',
        },      
        tooltip: {
            enabled: true,
            y: {
                formatter: function(val) {
                    return val;
                }
            }
        } 
    };

    return (
        <ReactApexChart options={options} series={series} type="donut" height="100%" width="100%"/>
    )
}